const HIDE_CONTENT_CLASS = 'overlay-hide-content';

export function overlayHide(node) {
  node.setAttribute('hidden', 'hidden');
  node.parentNode?.classList.remove(HIDE_CONTENT_CLASS);
}

export function overlayShow(node, hideContent = false) {
  if (node.parentNode) {
    if (hideContent) {
      node.parentNode.classList.add(HIDE_CONTENT_CLASS);
    }
    node.parentNode.style.position = 'relative';
  }
  node.removeAttribute('hidden');
}
